import { render } from "./IconHighlighter.vue?vue&type=template&id=9c2480fc"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconHighlighter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c2480fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c2480fc', __exports__)) {
    api.reload('9c2480fc', __exports__)
  }
  
  module.hot.accept("./IconHighlighter.vue?vue&type=template&id=9c2480fc", () => {
    api.rerender('9c2480fc', render)
  })

}


export default __exports__